// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — Autocomplete.classic.js, новая — Autocomplete.cp.js
import { isCp } from 'libs/design';
import * as classic from './Autocomplete.classic';
import * as cp from './Autocomplete.cp';

export default isCp ? cp.default : classic.default;
